import { symbols } from 'sf/helpers';

export const CURRENCIES = symbols('USD', 'GBP');

export const CURRENCY_SYMBOLS = {
  USD: '$',
  GBP: '£',
};
